import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { SystemConfigStructureItemType } from 'src/types/systemConfigDetail';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SyncIcon from '@mui/icons-material/Sync';
import SyncDisabledIcon from '@mui/icons-material/SyncDisabled';
import { ApplicationInstallType } from '../../types/ApplicationInstall';
export interface TopBlockPropsType {
    permissionUpdate: boolean;
    permissionUpdateStructure: boolean;
    permissionInstallApplication: boolean;
    permissionActivateApplicationInstall: boolean;
    permissionDeactivateApplicationInstall: boolean;
    editStructureData?: SystemConfigStructureItemType;
    handleSave: () => void;
    handleInstall: () => void;
    handleActivate: () => void;
    handleDeactivate: () => void;
    handleNewStructureData: () => void;
    applicationInstallData: ApplicationInstallType | null;
    integrationConfig?: boolean;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        label: translate('providerConfigDetail.action.newStructureItem'),
                        onClick: () => {
                            props.handleNewStructureData();
                        },
                        hidden: !props.permissionUpdateStructure || !props.editStructureData,
                    },
                    {
                        tooltip: translate('systemConfigDetail.action.installApplication'),
                        onClick: () => {
                            props.handleInstall();
                        },
                        icon: <CloudUploadIcon />,
                        hidden: !props.permissionInstallApplication || !props.integrationConfig,
                        variant: 'outlined',
                    },
                    {
                        tooltip: translate('systemConfigDetail.action.activateApplication'),
                        onClick: () => {
                            props.handleActivate();
                        },
                        icon: <SyncIcon />,
                        hidden: !props.permissionActivateApplicationInstall || !props.integrationConfig || !props.applicationInstallData || props.applicationInstallData?.active === true,
                        variant: 'outlined',
                    },
                    {
                        tooltip: translate('systemConfigDetail.action.deactivateApplication'),
                        onClick: () => {
                            props.handleDeactivate();
                        },
                        icon: <SyncDisabledIcon />,
                        hidden: !props.permissionDeactivateApplicationInstall || !props.integrationConfig || !props.applicationInstallData || props.applicationInstallData?.active === false,
                        variant: 'outlined',
                    },
                    {
                        label: translate('providerConfigDetail.action.save'),
                        onClick: () => {
                            props.handleSave();
                        },
                        hidden: !props.permissionUpdate,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
